import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import {
  EmailTemplateCreatePage,
  EmailTemplateEditPage,
  EmailTemplatesPage,
} from "./index";
 

export default (
  <Route path="email-templates">
    <Route
      index
      element={
        <Protected
          path="/admin/email-templates"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <EmailTemplatesPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/email-templates/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <EmailTemplateCreatePage />
        </Protected>
      }
    />
    
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/email-templates/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <EmailTemplateEditPage />
        </Protected>
      }
    />  
  </Route>
);



